import { Component } from '@angular/core';

@Component({
    selector: 'app-problem-with-the-service',
    templateUrl: './problem-with-the-service.component.html',
    standalone: false
})
export class ProblemWithTheServiceComponent {
  constructor() {}
}
